import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { gql } from '@apollo/client'
import { apolloClient } from 'lib/apollo'
import { Query, ShopStripeBalance } from 'types/graphql'
import { hideLoading, showLoading } from 'reducks/loading/operations'

const useQueryShopBalance = (shopId: string): ShopStripeBalance => {
  const dispatch = useDispatch()
  const [balance, setBalance] = useState<ShopStripeBalance>({ availableAmount: 0, pendingAmount: 0 })

  useEffect(() => {
    ;(async () => {
      if (!shopId) return
      const QUERY_BALANCE = gql(`
        query {
          shop(id: "${shopId}") {
            id
            name
            stripe {
              balance {
                availableAmount
                pendingAmount
              }
            }
          }
        }
      `)
      dispatch(showLoading())
      const { error, data } = await apolloClient.query<Query>({ query: QUERY_BALANCE })
      dispatch(hideLoading())
      if (error) {
        console.error(error)
        return
      }
      if (data?.shop?.stripe?.balance) {
        setBalance({ ...data.shop.stripe.balance })
      }
    })()
  }, [shopId])

  return balance
}

export default useQueryShopBalance
